import { render, staticRenderFns } from "./ProductTag.vue?vue&type=template&id=33dff1c0"
import script from "./ProductTag.vue?vue&type=script&lang=js"
export * from "./ProductTag.vue?vue&type=script&lang=js"
import style0 from "./ProductTag.vue?vue&type=style&index=0&id=33dff1c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports